import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './ScrollingText.pcss';

class ScrollingText extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        scrolledClassName: PropTypes.string
    };

    state = {
        ...this.getInitialListState(),
        original: this.props.children,
        rerenderKey: 0
    };

    getInitialListState() {
        return {
            currentIndex: 1,
            // Starting with a blank space allows us to decrement from 1 to 0 if next value is less
            lines: [undefined, this.props.children]
        };
    }

    onTransitionEnd = () => {
        this.setState({
            ...this.getInitialListState(this.props),
            // Force rerender after animation so we can reset state without animating
            rerenderKey: this.state.rerenderKey + 1
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const newChild = this.props.children;

        if (prevProps.children !== newChild) {
            const lastChild = prevState.lines[prevState.currentIndex];

            if (newChild !== lastChild) {
                const {currentIndex, lines} = this.state;
                let newLines = [...lines];
                let newCurrentIndex = currentIndex;

                if (Number(newChild) < Number(lastChild)) {
                    newCurrentIndex -= 1;
                    newLines = [
                        ...newLines.slice(0, newCurrentIndex),
                        newChild,
                        ...newLines.slice(newCurrentIndex + 1)
                    ];
                } else {
                    newCurrentIndex += 1;
                    newLines[newCurrentIndex] = newChild;
                }
                this.setState({
                    currentIndex: newCurrentIndex,
                    lines: newLines
                });
            }
        }
    }

    renderLine = (line, i = -1) => {
        const {scrolledClassName} = this.props;

        const {currentIndex, original} = this.state;

        const isVisible = i + 1 === currentIndex;

        const classes = cx({
            [scrolledClassName]: line !== original
        });

        return (
            <span aria-hidden={!isVisible} className={classes} key={i}>
                {line}
            </span>
        );
    };

    render() {
        const {currentIndex, lines, rerenderKey} = this.state;

        const [first, ...otherLines] = lines;
        // For proper display, only the first line has height. Use a nbsp when needed.
        const firstLine = typeof first !== 'undefined' ? first : <Fragment>&nbsp;</Fragment>;

        return (
            <span className={styles.wrapper} key={rerenderKey}>
                <span
                    className={styles.inner}
                    onTransitionEnd={this.onTransitionEnd}
                    style={{transform: `translateY(-${currentIndex * 100}%)`}}>
                    {this.renderLine(firstLine)}
                    <span className={styles.otherLineWrapper}>
                        {otherLines.map(this.renderLine)}
                    </span>
                </span>
            </span>
        );
    }
}

export default ScrollingText;
